import { ErrorMessage, InputField } from '../../shared/models';

export interface AdditionalInformation {
    tripID: InputField<string>;
    allowAgentCodeOverride: boolean;
    notes: InputField<string>;
    partnerPolicyNumbers: string;
    partnerSubmittedPrice: number;
    validationMessages: ErrorMessage[];
}